
export const ShowToast = async ( toast, apiCall, successMessage, errorMessage) => {

    
  const condition = apiCall
  .then((response) => {
    // Resolve with success message and the response data
    Promise.resolve({ message: successMessage, data: response.data });
    return { data: response };
     // The data is what we use in success toast
  })
  .catch((error) => {
    // Reject with error message and handle error details
    return Promise.reject({ message: errorMessage, error: error.response?.data || error.message });
  });

    // Create an example promise that resolves in 5s
    //const condition = new Promise((resolve, reject) => {
      
    //  setTimeout(() => {
     //   if(isSuccess){
     //     resolve({message: value})
     //   } else {
     //     reject({message: value})
     //   }
    //  }, 5000)
  //  })

    // Will display the loading toast until the promise is either resolved
    // or rejected.
    toast.promise(condition, {
      success: { title: 'Success !', description: ({ data }) => data.message,  position: 'top' },
      error: { title: 'Error !', description: ({ data }) => data.message,  position: 'top'},
      loading: { title: 'Loading !', description: 'Please wait',  position: 'top' },
    })
  
}
